import { MobiTalkSource } from '@orcar/common';
import { useSearchParams } from 'react-router-dom';
import {
  useCreateMobiTalkChat,
  useSendMobiTalkMessage,
} from '@/hooks/reactQuery/mobi-talk.hook';

const Card = () => {
  return (
    <div className='flex h-[284px] w-[200px] items-end rounded-m bg-primary-020 bg-[url(/svg/car.svg)] bg-auto bg-right-top bg-no-repeat p-5'>
      <p className='whitespace-pre-line text-[16px] font-bold leading-6 text-primary-090'>{`Start\nNew Booking`}</p>
    </div>
  );
};

const Text = ({ text }: { text: string }) => {
  return (
    <p className='font-montserrat whitespace-pre-line text-[16px] font-normal leading-6 text-primary-090'>
      {text}
    </p>
  );
};

const WelcomeSection = () => {
  const [getSearchParams, setSearchParams] = useSearchParams();

  const { mutateAsync: createChatRoom } = useCreateMobiTalkChat();
  const { mutate: sendMessage } = useSendMobiTalkMessage();

  const handleSubmit = async (text: string) => {
    const room = await createChatRoom({
      companyId: import.meta.env.VITE_COMPANY_ID,
    });

    sendMessage({
      id: room.id,
      input: {
        text,
        source:
          getSearchParams.get('source') === 'sure'
            ? MobiTalkSource.SURE
            : MobiTalkSource.D2C,
      },
    });

    setSearchParams({ roomId: room.id.toString() });
  };

  return (
    <>
      <div className='flex flex-col items-center justify-center gap-[60px]'>
        <p className='font-montserrat whitespace-pre-line text-center text-[24px] font-normal text-primary-090'>
          {`Ready for an amazing trip?\nWe’ll help you book the`}
          <span className='font-bold'> perfect rental car</span>!
        </p>
        <div className='flex gap-3'>
          {/* Start New Booking */}
          <div
            className='flex h-[284px] w-[200px] cursor-pointer items-end rounded-m bg-grey-000 bg-[url(/svg/car.svg)] bg-auto bg-right-top bg-no-repeat p-5 shadow-[0px_0px_10px_0px_rgba(26,26,26,0.10)] hover:bg-primary-020'
            onClick={() => handleSubmit('I want to ask a question.')}
          >
            <p className='font-montserrat whitespace-pre-line text-[16px] font-bold leading-6 text-primary-090'>{`Start\nNew Booking`}</p>
          </div>
          {/* Check Reservation */}
          <div className='flex w-[200px] flex-col gap-3'>
            <div className='flex h-full cursor-pointer items-end rounded-m bg-grey-000 p-5 shadow-[0px_0px_10px_0px_rgba(26,26,26,0.10)] hover:bg-primary-020'>
              <Text text={`Check My\nReservation`} />
            </div>
            <div className='flex h-full cursor-pointer items-end rounded-m bg-grey-000 p-5 shadow-[0px_0px_10px_0px_rgba(26,26,26,0.10)] hover:bg-primary-020'>
              <Text text={`Cancel My\nReservation`} />
            </div>
          </div>

          <div className='flex w-[416px] flex-col gap-3'>
            <div className='flex w-full gap-3'>
              <div className='flex size-full cursor-pointer items-end justify-center rounded-m bg-grey-000 p-5 shadow-[0px_0px_10px_0px_rgba(26,26,26,0.10)] hover:bg-primary-020'>
                <p className='whitespace-pre-line text-[16px] font-normal leading-6 text-primary-090'>
                   Don’t know where to start?{` `}
                  <span className='text-[16px] font-bold leading-6 text-primary-090'>
                    Ask Mobi
                  </span>
                  {` `}for help!
                </p>
              </div>
            </div>
            <div className='flex size-full gap-3'>
              <div className='flex w-full flex-1 cursor-pointer items-end rounded-m bg-grey-000 bg-[url(/svg/calendar.svg)] bg-auto bg-right-top bg-no-repeat p-5 shadow-[0px_0px_10px_0px_rgba(26,26,26,0.10)] hover:bg-primary-020'>
                <Text text={`Expand My\n Rental`} />
              </div>
              <div className='flex w-full flex-1 cursor-pointer items-end rounded-m bg-grey-000 bg-[url(/svg/search.svg)] bg-auto bg-right-top bg-no-repeat p-5 shadow-[0px_0px_10px_0px_rgba(26,26,26,0.10)] hover:bg-primary-020'>
                <Text text={`View Terms \n& Insurance`} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className='font-montserrat absolute bottom-10 whitespace-pre-line text-center text-caption1 tracking-xl text-primary-070'>{`Mobi is here to help.\nIt might make mistakes, but it learns from you.`}</p>
    </>
  );
};

export default WelcomeSection;
